import { render, staticRenderFns } from "./publishLoadDocument.vue?vue&type=template&id=5845c079&scoped=true&"
import script from "./publishLoadDocument.vue?vue&type=script&lang=js&"
export * from "./publishLoadDocument.vue?vue&type=script&lang=js&"
import style0 from "./publishLoadDocument.vue?vue&type=style&index=0&id=5845c079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845c079",
  null
  
)

export default component.exports